import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../account.css";
import "./accountFavorites.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import { Heart, MapPin } from "lucide-react";

const AccountFavorites = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();
	const t = translations[language]?.account?.favorites || {};

	// Mock favourites array for now – replace with real API data when ready
	const favourites = []; // e.g. [{ shopId, name, image, address }]

	return (
		<div className="ac-page apfv">
			<header className="ac-head">
				{/* <span className="ac-eyebrow">{translations[language]?.account?.menu?.favorites || "Favourites"}</span> */}
				<h1 className="ac-title">{t.title}</h1>
				{t.subtitle && <p className="ac-sub">{t.subtitle}</p>}
			</header>

			{favourites.length === 0 ? (
				<div className="ac-empty">
					<span className="ac-icon is-gold">
						<Heart size={18} />
					</span>
					<p>{t.empty}</p>
					<button className="ac-btn ac-btn--sm" onClick={() => navigate("/")}>
						{t.explore}
					</button>
				</div>
			) : (
				<div className="apfv-grid">
					{favourites.map((shop) => (
						<button key={shop.shopId} className="apfv-card" onClick={() => navigate(`/shops/${shop.shopId}`)}>
							<span className="apfv-thumb">
								<img src={shop.image || "/default_shop.png"} alt="" />
							</span>

							<span className="apfv-copy">
								<span className="apfv-name">{shop.name}</span>
								<span className="apfv-address">
									<MapPin size={12} />
									{shop.address}
								</span>
							</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default AccountFavorites;
